import React from 'react'
import * as typeformEmbed from '@typeform/embed'

export default class Footerform extends React.Component {
  constructor(props) {
    super(props)
    this.state = {

    }
  }
  render() {
    const { footerFormTitle, buttonText, buttonUrl } = this.props;
    let typeForm
    if (process && process.browser) {
      typeForm = typeformEmbed.makePopup(
        buttonUrl,
        {
          opacity: 55,
          buttonText: "Request Invite",
          hideScrollbars: true,
          onSubmit: function () {
            setTimeout(() => typeForm.close(), 2000)
          }
        }
      )
    }
    return (
      <section className={`py-5 footer-form-wrapper`} >
        <div className="container footer-form">
          <div className="row">
            <div className="col-12 col-md-11 mx-auto">
              <div className="row align-items-center">
                <div className="col-12 col-md-8 col-lg-9">
                  <div className="text-center text-lg-left mb-3 mb-lg-0">
                    <h2 className="md-font">{footerFormTitle}</h2>
                  </div>
                </div>
                <div className="col-12 col-md-4 col-lg-3 ml-lg-auto">
                  <div className="row">
                    <div className="col-12 col-md-12 mx-auto text-center">
                      {/* eslint-disable-next-line  */}
                      <a
                        href="#"
                        onClick={() => {
                          process && process.browser &&
                            typeForm.open()
                        }}
                        className="btn mb-2 sm-font pirlo-btn">
                        {buttonText ? buttonText : "Request Invite"}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

